import { render, staticRenderFns } from "./NewPublisherModal.vue?vue&type=template&id=3e3a8d54&lang=pug&"
import script from "./NewPublisherModal.vue?vue&type=script&lang=js&"
export * from "./NewPublisherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports